export const BANNERS_DB_KEY = 'banners-3.27'
